import classNames from 'classnames';
import React from 'react';
import * as styles from './Breadcrumb.module.scss';
import Caret from './Caret';
import Link from '../utils/router/Link';

const CARET_SIZE = parseInt(styles.caretSize, 10);

interface BreadcrumbProps {
  name: React.ReactNode;
  to?: string;
  truncate?: boolean;
  priority?: 'max' | 'high';
  hideCaret?: boolean;
  collapsed?: boolean;
  maximumAllowedContainerSpace?: number;
}

const Breadcrumb = ({
  name,
  to,
  truncate = false,
  priority,
  hideCaret = false,
  collapsed,
  maximumAllowedContainerSpace,
}: BreadcrumbProps) => {
  return (
    <li
      className={classNames(styles.container, {
        [styles.maxPriority]: priority === 'max',
        [styles.highPriority]: priority === 'high',
        [styles.truncate]: truncate,
        [styles.collapsed]: collapsed,
      })}
      style={
        maximumAllowedContainerSpace
          ? ({
              '--maximum-allowed-container-space': `${maximumAllowedContainerSpace}px`,
            } as React.CSSProperties)
          : undefined
      }
    >
      {collapsed ? (
        <div className={styles.ellipsis}>&hellip;</div>
      ) : (
        <div className={styles.name}>
          {to ? <Link to={to}>{name}</Link> : name}
        </div>
      )}

      {!hideCaret && (
        <div className={styles.caret}>
          <Caret direction="right" size={CARET_SIZE} />
        </div>
      )}
    </li>
  );
};

export default Breadcrumb;
